module.exports = __webpack_public_path__ + "img/product-detail-meeting-promo-bg.245f627.jpg";